module.exports = __webpack_public_path__ + "img/leaseJump.816893a2.png";